<template>
<div class="chapter">
<div class="inner_page">
<div id="Stranded_eBook.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="EB" id="toc_marker-1">STRANDED</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Stranded_eBook.vue?beac32d8